<template>
    <div class="dt-mainCard">
        <div class="dt-mainCard__head">
            <div class="container">
                <div class="dt-mainCard__head-navBack">
                    <a href="" class='block-btnNavBack'></a>
                </div>
                <div class="dt-mainCard__head-content">
                    <div class="dt-mainCard__head-content-imageColumn">
                        <div class="skeleton-image skeleton-animation square mb15"></div>
                    </div>
                    <div class="dt-mainCard__head-content-defaultColumn">
                        <div class="skeleton-title skeleton-animation width70 mb15"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="dt-mainCard__contentWrapper">
            загрузка....
        </div>
    </div>
</template>
<script>
export default {}
</script>
